import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createSummaryReportSlice = (set, get) => ({
    summary: {
        loading: false,
        data: {}
    },
    getSummary: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ summary: { ...state.summary, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: '/v1/businessPanel/BusinessCounts/null/null',
                headers: { token }
            });
            set(state => ({ summary: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ summary: { ...state.summary, loading: false } }));
        }
    }
});
